import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { PAYROLL_COMPANIES, } from "../../catalogs/payrollCompanies";
import {
    FiSlack,
    FiAlertCircle,
    FiCheckCircle,
} from "react-icons/fi";
import "./Payroll.css";
import { useNavigate } from "react-router-dom";

const API =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5000";

const MONTH_NAMES = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

const Payroll = () => {
    const [showModal, setShowModal] = useState(false);
    const [activeTab, setActiveTab] = useState("dashboard");
    const [processes, setProcesses] = useState([]);
    const [, setLoadingProcesses] = useState(false);
    const [openingProcessId, setOpeningProcessId] = useState(null);
    const navigate = useNavigate();

    const [formData, setFormData] =
        useState({
            processType: "CLIENT",
            company: "",
            month:
                new Date().getMonth() + 1,
            year:
                new Date().getFullYear(),
            frequency: "MONTHLY",
            fortnight: null,
            observations: "",
        });

    useEffect(() => {
        loadProcesses();
    }, []);

    const loadProcesses = async () => {
        try {
            setLoadingProcesses(true);

            const token =
                localStorage.getItem("token") ||
                sessionStorage.getItem("token");

            const response = await axios.get(
                `${API}/api/payroll/processes`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setProcesses(
                response.data.data || []
            );
        } catch (error) {
            console.error(
                "Error cargando procesos:",
                error
            );

            toast.error(
                error?.response?.data?.message ||
                "No fue posible consultar los procesos."
            );
        } finally {
            setLoadingProcesses(false);
        }
    };

    const handleOpenProcess = async (
        process
    ) => {
        try {

            setOpeningProcessId(
                process._id
            );

            const hasDeductions =
                process.files?.deductions;

            const hasReport =
                process.files?.report;

            if (
                hasDeductions &&
                hasReport
            ) {

                const token =
                    localStorage.getItem("token") ||
                    sessionStorage.getItem("token");

                await axios.post(
                    `${API}/api/payroll/processes/${process._id}/compare`,
                    {},
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            }

            navigate(
                `/payroll/client/${process._id}`
            );

        } catch (error) {

            console.error(
                "Error ejecutando proceso:",
                error
            );

            toast.error(
                error?.response?.data?.message ||
                "No fue posible procesar la nómina."
            );

        } finally {

            setOpeningProcessId(
                null
            );

        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFormData((currentFormData) => {
            if (name === "processType") {
                return {
                    ...currentFormData,
                    processType: value,
                    company: "",
                    frequency:
                        value === "MISSION"
                            ? "BIWEEKLY"
                            : "MONTHLY",
                    fortnight:
                        value === "MISSION"
                            ? 1
                            : null,
                };
            }

            if (name === "frequency") {
                return {
                    ...currentFormData,
                    frequency: value,
                    fortnight:
                        value === "BIWEEKLY"
                            ? currentFormData.fortnight || 1
                            : null,
                };
            }

            return {
                ...currentFormData,
                [name]: value,
            };
        });
    };


    const handleCreateProcess = async (e) => {
        try {
            e.preventDefault();

            const token =
                localStorage.getItem("token") ||
                sessionStorage.getItem("token");

            await axios.post(
                `${API}/api/payroll/processes`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success(
                "Proceso creado correctamente."
            );

            setShowModal(false);

            loadProcesses();

            setFormData({
                processType: "CLIENT",
                company: "",
                month: new Date().getMonth() + 1,
                year: new Date().getFullYear(),
                frequency: "MONTHLY",
                observations: "",
            });

        } catch (error) {
            console.error(error);

            toast.error(
                error?.response?.data?.message ||
                "No fue posible crear el proceso."
            );
        }
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "EXPORTED":
            case "RECONCILED":
                return "payroll-status payroll-status-success";

            case "CREATED":
            case "DEDUCTIONS_UPLOADED":
            case "REPORT_UPLOADED":
                return "payroll-status payroll-status-warning";

            case "PROCESSING":
                return "payroll-status payroll-status-processing";

            case "WITH_DIFFERENCES":
                return "payroll-status payroll-status-difference";

            case "ERROR":
                return "payroll-status payroll-status-danger";

            default:
                return "payroll-status payroll-status-default";
        }
    };

    const getStatusLabel = (status) => {
        const statusLabels = {
            CREATED: "Creado",
            DEDUCTIONS_UPLOADED:
                "Deducciones cargadas",
            REPORT_UPLOADED:
                "Reporte cargado",
            PROCESSING:
                "Procesando",
            WITH_DIFFERENCES:
                "Con diferencias",
            RECONCILED:
                "Conciliado",
            EXPORTED:
                "ERP generado",
            ERROR:
                "Error",
        };

        return statusLabels[status] || "Sin estado";
    };

    const currentDate = new Date();

    const currentMonth =
        currentDate.getMonth() + 1;

    const currentYear =
        currentDate.getFullYear();

    const currentMonthName =
        MONTH_NAMES[currentMonth - 1];

    const missionCompanyNames = [
        "Manpower Mision Quincenal-Semanal",
        "Manpower Mision Mensual",
    ];

    const allCompanyNames =
        Object.keys(PAYROLL_COMPANIES);

    const clientCompanyNames =
        allCompanyNames.filter(
            (company) =>
                !missionCompanyNames.includes(
                    company
                )
        );

    const availableCompanies =
        formData.processType === "MISSION"
            ? missionCompanyNames.filter(
                (company) =>
                    Object.prototype.hasOwnProperty.call(
                        PAYROLL_COMPANIES,
                        company
                    )
            )
            : clientCompanyNames;

    const clientProcesses =
        processes.filter(
            (process) =>
                process.processType === "CLIENT"
        );

    const missionProcesses =
        processes.filter(
            (process) =>
                process.processType === "MISSION"
        );

    const currentMonthClientProcesses =
        clientProcesses.filter(
            (process) =>
                Number(process.period?.month) ===
                currentMonth &&
                Number(process.period?.year) ===
                currentYear
        );

    const companiesWithCurrentProcess =
        new Set(
            currentMonthClientProcesses.map(
                (process) =>
                    String(
                        process.company || ""
                    ).trim()
            )
        );

    const pendingReports =
        currentMonthClientProcesses.filter(
            (process) =>
                !process.files?.report?.uploadedAt
        ).length;

    const pendingProcessesToCreate =
        Math.max(
            clientCompanyNames.length -
            companiesWithCurrentProcess.size,
            0
        );

    const completedCurrentProcesses =
        currentMonthClientProcesses.filter(
            (process) =>
                [
                    "RECONCILED",
                    "EXPORTED",
                ].includes(process.status)
        ).length;

    const currentMonthCoverage =
        clientCompanyNames.length > 0
            ? Math.round(
                (
                    companiesWithCurrentProcess
                        .size /
                    clientCompanyNames.length
                ) * 100
            )
            : 0;

    const recentActivity = [
        ...processes,
    ]
        .sort(
            (firstProcess, secondProcess) =>
                new Date(
                    secondProcess.updatedAt ||
                    secondProcess.createdAt
                ) -
                new Date(
                    firstProcess.updatedAt ||
                    firstProcess.createdAt
                )
        )
        .slice(0, 3);

    const formatPeriod = (process) => {
        const month =
            MONTH_NAMES[
            Number(
                process.period?.month || 1
            ) - 1
            ] || "-";

        const year =
            process.period?.year || "-";

        const fortnight =
            process.period?.fortnight
                ? ` · Quincena ${process.period.fortnight}`
                : "";

        return `${month} ${year}${fortnight}`;
    };

    const formatDate = (date) => {
        if (!date) {
            return "-";
        }

        return new Date(
            date
        ).toLocaleString("es-CO", {
            dateStyle: "medium",
            timeStyle: "short",
        });
    };

    const getActivityDescription = (
        process
    ) => {
        if (
            process.status === "EXPORTED"
        ) {
            return `${formatPeriod(
                process
            )} exportado al ERP`;
        }

        if (
            process.status === "RECONCILED"
        ) {
            return `${formatPeriod(
                process
            )} conciliado correctamente`;
        }

        if (
            process.status ===
            "WITH_DIFFERENCES"
        ) {
            return `${process.summaries?.comparison
                ?.differences || 0
                } diferencias pendientes`;
        }

        if (
            !process.files?.deductions
                ?.uploadedAt
        ) {
            return "Pendiente cargar deducciones";
        }

        if (
            !process.files?.report?.uploadedAt
        ) {
            return "Pendiente cargar reporte";
        }

        return getStatusLabel(
            process.status
        );
    };

    return (
        <div className="payroll-container">
            <div className="payroll-header">
                <div>
                    <h1>|  Nóminas</h1>
                </div>

                <button
                    className="payr-btn-primary"
                    onClick={() => setShowModal(true)}
                >
                    <FiSlack size={15} />
                    Nuevo proceso
                </button>
            </div>

            <div className="payroll-tabs">
                <button
                    className={`payroll-tab ${activeTab === "dashboard" ? "active" : ""
                        }`}
                    onClick={() => setActiveTab("dashboard")}
                >
                    Resumen
                </button>

                <button
                    className={`payroll-tab ${activeTab === "clients" ? "active" : ""
                        }`}
                    onClick={() => setActiveTab("clients")}
                >
                    Clientes
                </button>

                <button
                    className={`payroll-tab ${activeTab === "mission" ? "active" : ""
                        }`}
                    onClick={() => setActiveTab("mission")}
                >
                    Misión
                </button>

                <button
                    className={`payroll-tab ${activeTab === "history" ? "active" : ""
                        }`}
                    onClick={() => setActiveTab("history")}
                >
                    Historial
                </button>
            </div>

            {activeTab === "dashboard" && (
                <>
                    <div className="payroll-metrics">

                        <div className="payroll-metric-card">
                            <span>Clientes activos</span>

                            <strong>
                                {clientCompanyNames.length
                                    .toLocaleString("es-CO")}
                            </strong>

                            <small>
                                Empresas del catálogo de clientes
                            </small>
                        </div>

                        <div className="payroll-metric-card">
                            <span>Procesos creados</span>

                            <strong>
                                {currentMonthClientProcesses
                                    .length
                                    .toLocaleString("es-CO")}
                            </strong>

                            <small>
                                Nóminas procesadas en{" "}
                                {currentMonthName}
                            </small>
                        </div>

                        <div className="payroll-metric-card">
                            <span>Reportes pendientes</span>

                            <strong>
                                {pendingReports.toLocaleString(
                                    "es-CO"
                                )}
                            </strong>

                            <small>
                                Procesos sin reporte cargado
                            </small>
                        </div>

                        <div className="payroll-metric-card">
                            <span>Pendientes por crear</span>

                            <strong>
                                {pendingProcessesToCreate
                                    .toLocaleString("es-CO")}
                            </strong>

                            <small>
                                Clientes sin proceso en{" "}
                                {currentMonthName}
                            </small>
                        </div>

                    </div>

                    <div className="payroll-dashboard-grid">

                        <div className="payroll-widget">

                            <div className="payroll-widget-header">
                                <h3>Actividad reciente</h3>
                            </div>

                            <div className="payroll-activity-list">

                                {recentActivity.length > 0 ? (
                                    recentActivity.map(
                                        (process) => (
                                            <div
                                                className="payroll-activity-item"
                                                key={process._id}
                                            >
                                                <div
                                                    className={`payroll-dot ${getStatusClass(
                                                        process.status
                                                    )}`}
                                                />

                                                <div className="payroll-activity-content">
                                                    <div className="payroll-activity-title">
                                                        <strong>
                                                            {process.company}
                                                        </strong>

                                                        <small>
                                                            {formatDate(
                                                                process.updatedAt ||
                                                                process.createdAt
                                                            )}
                                                        </small>
                                                    </div>

                                                    <p>
                                                        {getActivityDescription(
                                                            process
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                    )
                                ) : (
                                    <div className="payroll-empty-state">
                                        No existen procesos recientes.
                                    </div>
                                )}

                            </div>

                        </div>

                        <div className="payroll-widget">

                            <div className="payroll-widget-header">
                                <h3>
                                    Resumen de {currentMonthName}
                                </h3>
                            </div>

                            <div className="payroll-summary-row">
                                <span>
                                    Cobertura del periodo
                                </span>

                                <strong>
                                    {currentMonthCoverage}%
                                </strong>
                            </div>

                            <div className="payroll-summary-row">
                                <span>
                                    Clientes con proceso
                                </span>

                                <strong>
                                    {companiesWithCurrentProcess
                                        .size
                                        .toLocaleString("es-CO")}
                                </strong>
                            </div>

                            <div className="payroll-summary-row">
                                <span>
                                    Procesos conciliados
                                </span>

                                <strong>
                                    {completedCurrentProcesses
                                        .toLocaleString("es-CO")}
                                </strong>
                            </div>

                            <div className="payroll-summary-row">
                                <span>
                                    Procesos con diferencias
                                </span>

                                <strong>
                                    {currentMonthClientProcesses
                                        .filter(
                                            (process) =>
                                                process.status ===
                                                "WITH_DIFFERENCES"
                                        )
                                        .length
                                        .toLocaleString("es-CO")}
                                </strong>
                            </div>

                        </div>

                    </div>
                </>
            )}

            {activeTab === "clients" && (
                <div className="payroll-panel">
                    <div className="payroll-section-header">
                        <h2>Nómina Clientes</h2>
                    </div>

                    <table className="payroll-table">
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th>Periodo</th>
                                <th>Estado</th>
                                <th>Deducciones</th>
                                <th>Reporte</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            {clientProcesses.map(
                                (process) => (
                                    <tr key={process._id}>

                                        <td>
                                            {process.company}
                                        </td>

                                        <td>
                                            {process.period?.month}/
                                            {process.period?.year}
                                        </td>

                                        <td>
                                            <span
                                                className={getStatusClass(
                                                    process.status
                                                )}
                                            >
                                                {getStatusLabel(process.status)}
                                            </span>
                                        </td>

                                        <td>
                                            {process.files?.deductions ? (
                                                <FiCheckCircle color="#333333" size={18} />
                                            ) : (
                                                <FiAlertCircle color="#333333" size={18} />
                                            )}
                                        </td>

                                        <td>
                                            {process.files?.report ? (
                                                <FiCheckCircle color="#333333" size={18} />
                                            ) : (
                                                <FiAlertCircle color="#333333" size={18} />
                                            )}
                                        </td>

                                        <td>
                                            <button
                                                className="payroll-action-button"
                                                onClick={() =>
                                                    handleOpenProcess(process)
                                                }
                                                disabled={
                                                    openingProcessId ===
                                                    process._id
                                                }
                                            >
                                                {
                                                    openingProcessId ===
                                                        process._id
                                                        ? "Procesando..."
                                                        : "Abrir"
                                                }
                                            </button>
                                        </td>

                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            )}

            {activeTab === "mission" && (
                <div className="payroll-panel">

                    <div className="payroll-section-header">
                        <h2>Nómina Misión</h2>
                    </div>

                    <div className="payroll-table-container">
                        <table className="payroll-table">

                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Periodo</th>
                                    <th>Estado</th>
                                    <th>Deducciones</th>
                                    <th>Reporte</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>

                            <tbody>
                                {missionProcesses.length > 0 ? (
                                    missionProcesses.map(
                                        (process) => (
                                            <tr key={process._id}>

                                                <td>
                                                    {process.company}
                                                </td>

                                                <td>
                                                    {formatPeriod(
                                                        process
                                                    )}
                                                </td>

                                                <td>
                                                    <span
                                                        className={getStatusClass(
                                                            process.status
                                                        )}
                                                    >
                                                        {getStatusLabel(
                                                            process.status
                                                        )}
                                                    </span>
                                                </td>

                                                <td>
                                                    {process.files?.deductions
                                                        ?.uploadedAt ? (
                                                        <FiCheckCircle
                                                            size={18}
                                                        />
                                                    ) : (
                                                        <FiAlertCircle
                                                            size={18}
                                                        />
                                                    )}
                                                </td>

                                                <td>
                                                    {process.files?.report
                                                        ?.uploadedAt ? (
                                                        <FiCheckCircle
                                                            size={18}
                                                        />
                                                    ) : (
                                                        <FiAlertCircle
                                                            size={18}
                                                        />
                                                    )}
                                                </td>

                                                <td>
                                                    <button
                                                        className="payroll-action-button"
                                                        onClick={() =>
                                                            handleOpenProcess(
                                                                process
                                                            )
                                                        }
                                                    >
                                                        Abrir
                                                    </button>
                                                </td>

                                            </tr>
                                        )
                                    )
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="6"
                                            className="payroll-table-empty"
                                        >
                                            No existen procesos de
                                            nómina de misión.
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                </div>
            )}

            {activeTab === "history" && (
                <div className="payroll-panel">

                    <div className="payroll-section-header">
                        <h2>
                            Historial de Procesos
                        </h2>
                    </div>

                    <div className="payroll-table-container">
                        <table className="payroll-table">

                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Tipo</th>
                                    <th>Periodo</th>
                                    <th>Última actualización</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>

                            <tbody>
                                {[...processes]
                                    .sort(
                                        (
                                            firstProcess,
                                            secondProcess
                                        ) =>
                                            new Date(
                                                secondProcess.updatedAt
                                            ) -
                                            new Date(
                                                firstProcess.updatedAt
                                            )
                                    )
                                    .map((process) => (
                                        <tr key={process._id}>

                                            <td>
                                                {process.company}
                                            </td>

                                            <td>
                                                {process.processType ===
                                                    "MISSION"
                                                    ? "Misión"
                                                    : "Cliente"}
                                            </td>

                                            <td>
                                                {formatPeriod(process)}
                                            </td>

                                            <td>
                                                {formatDate(
                                                    process.updatedAt
                                                )}
                                            </td>

                                            <td>
                                                <span
                                                    className={getStatusClass(
                                                        process.status
                                                    )}
                                                >
                                                    {getStatusLabel(
                                                        process.status
                                                    )}
                                                </span>
                                            </td>

                                            <td>
                                                <button
                                                    className="payroll-action-button"
                                                    onClick={() =>
                                                        handleOpenProcess(
                                                            process
                                                        )
                                                    }
                                                >
                                                    Abrir
                                                </button>
                                            </td>

                                        </tr>
                                    ))}
                            </tbody>

                        </table>
                    </div>

                </div>
            )}

            {showModal && ( 
                <div
                    className="payroll-modal-overlay"
                    onClick={() => setShowModal(false)}
                >
                    <div
                        className="payroll-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="payroll-modal-header">
                            <h2>Nuevo Proceso de Nómina</h2>

                            <button
                                className="payroll-close-button"
                                onClick={() => setShowModal(false)}
                            >
                                ×
                            </button>
                        </div>

                        <form onSubmit={handleCreateProcess}>
                            <div className="payroll-form-grid">
                                <div className="payroll-form-group">
                                    <label>Tipo de Proceso</label>

                                    <select
                                        name="processType"
                                        value={formData.processType}
                                        onChange={handleChange}
                                    >
                                        <option value="CLIENT">
                                            Cliente
                                        </option>

                                        <option value="MISSION">
                                            Misión
                                        </option>
                                    </select>
                                </div>

                                <div className="payroll-form-group">
                                    <label>Empresa</label>

                                    <select
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Seleccione empresa
                                        </option>

                                        {availableCompanies.map(
                                            (company) => (
                                                <option
                                                    key={company}
                                                    value={company}
                                                >
                                                    {company}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className="payroll-form-group">
                                    <label>Mes</label>

                                    <select
                                        name="month"
                                        value={formData.month}
                                        onChange={handleChange}
                                    >
                                        {[...Array(12)].map((_, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="payroll-form-group">
                                    <label>Año</label>

                                    <input
                                        type="number"
                                        name="year"
                                        value={formData.year}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="payroll-form-group">
                                    <label>Frecuencia</label>

                                    <select
                                        name="frequency"
                                        value={formData.frequency}
                                        onChange={handleChange}
                                    >
                                        <option value="MONTHLY">
                                            Mensual
                                        </option>

                                        <option value="BIWEEKLY">
                                            Quincenal
                                        </option>
                                    </select>
                                </div>

                                {formData.frequency ===
                                    "BIWEEKLY" && (
                                        <div className="payroll-form-group">

                                            <label>Quincena</label>

                                            <select
                                                name="fortnight"
                                                value={
                                                    formData.fortnight || 1
                                                }
                                                onChange={handleChange}
                                            >
                                                <option value={1}>
                                                    Primera quincena
                                                </option>

                                                <option value={2}>
                                                    Segunda quincena
                                                </option>
                                            </select>

                                        </div>
                                    )}
                            </div>

                            <div className="payroll-form-group payroll-textarea">
                                <label>Observaciones</label>

                                <textarea
                                    name="observations"
                                    rows="4"
                                    value={formData.observations}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="payroll-modal-actions">

                                <button
                                    type="submit"
                                    className="payr-btn-primary"
                                >
                                    Crear proceso
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Payroll;